// Asset URLs
const A_BOILER_TUBE = "https://customer-assets.emergentagent.com/job_weld-overlay-tech/artifacts/vmw6yy5s_Boiler%20Tube%20WOL%20System%20.png";
const A_BOILER_WALL = "https://customer-assets.emergentagent.com/job_weld-overlay-tech/artifacts/b92pxada_Boiler%20Wall%20System%20render%20Image.png";
const A_BUTT_WELD   = "https://customer-assets.emergentagent.com/job_weld-overlay-tech/artifacts/usus4vmk_Butt%20Welding%20Ssytem.png";
const A_AUTO_DPT    = "https://customer-assets.emergentagent.com/job_weld-overlay-tech/artifacts/ajhnv5ky_Auto%20DYE%20PENETRANT%20TESTING%20SKID.png";

// Existing Weldmatix product photography (kept where applicable)
const W_DRT       = "https://customer-assets.emergentagent.com/job_weld-overlay-tech/artifacts/3o6qbkbj_DRT%20Render%20Model.26.webp";
const W_DRT_HERO  = "https://customer-assets.emergentagent.com/job_weld-overlay-tech/artifacts/3o6qbkbj_DRT%20Render%20Model.26.webp";
const W_PIPE      = "https://customer-assets.emergentagent.com/job_weld-overlay-tech/artifacts/2o2oz355_PIPE%20RIG.png";
const W_PIPE_HERO = "https://customer-assets.emergentagent.com/job_weld-overlay-tech/artifacts/2o2oz355_PIPE%20RIG.png";
const W_VCS       = "https://customer-assets.emergentagent.com/job_weld-overlay-tech/artifacts/yoyvceri_System%20Image-VCS-1.jpg";
const W_DPT_OLD   = "https://customer-assets.emergentagent.com/job_weld-overlay-tech/artifacts/ajhnv5ky_Auto%20DYE%20PENETRANT%20TESTING%20SKID.png";

// Official Weldmatix renders (new)
const A_OMNI      = "https://customer-assets.emergentagent.com/job_weld-overlay-tech/artifacts/q8jbm0wc_OMNI%20Clad%20System%20.png";
const A_OMNI_LASER= "https://customer-assets.emergentagent.com/job_weld-overlay-tech/artifacts/3qxwhh6q_OMNI%20LASER%20CLAD%20%202.0%20.png";
const A_LASER     = "https://customer-assets.emergentagent.com/job_weld-overlay-tech/artifacts/hn1q2mys_LASER%20WELD%20OVERLAY%20SYSTEM.png";
const A_CUSTOM_1  = "https://customer-assets.emergentagent.com/job_weld-overlay-tech/artifacts/c6tmv5fs_Custom%20Built%20Tank%20cir%20seam%20.png";
const A_CUSTOM_2  = "https://customer-assets.emergentagent.com/job_weld-overlay-tech/artifacts/x5x6h0jg_CUSTOM%20BUILT%20SYSTEMS.png";

// Stock industrial fallbacks (high-quality, complementary)
const STK_LASER    = "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?auto=format&fit=crop&w=1600&q=80";
const STK_LASER_2  = "https://images.unsplash.com/photo-1517420704952-d9f39e95b43e?auto=format&fit=crop&w=1600&q=80";
const STK_FACTORY  = "https://images.unsplash.com/photo-1581094271901-8022df4466f9?auto=format&fit=crop&w=1600&q=80";
const STK_FACTORY_2= "https://images.unsplash.com/photo-1581093588401-fbb62a02f120?auto=format&fit=crop&w=1600&q=80";
const STK_WELD_ARC = "https://images.pexels.com/photos/1216589/pexels-photo-1216589.jpeg?auto=compress&cs=tinysrgb&w=1600";
const STK_BOILER   = "https://images.unsplash.com/photo-1611273426858-450d8e3c9fce?auto=format&fit=crop&w=1600&q=80";

export const PRODUCTS = [
  {
    slug: "omni-clad-station",
    name: "Omni-Clad Station",
    short: "OMNI · Dual-Orientation Cladding Cell",
    tagline: "Dual-orientation cladding cell with integrated butt-welding. One cell. Every overlay job.",
    image: A_OMNI,
    image_secondary: A_OMNI,
    hero: A_OMNI,
    description:
      "The Omni-Clad Station is a dual-orientation cladding cell that consolidates overlay, fillet and butt welding into a single platform. Geometry-agnostic, operator-first HMI, and a modular service-friendly architecture make it the ideal choice for shops handling mixed-part families.",
    features: [
      "Dual orientation — vertical & horizontal cladding",
      "Integrated butt-welding capability",
      "Geometry-agnostic part holding",
      "Hot Wire TIG / GMAW process options",
      "Operator-first HMI with recipe management",
      "Modular service-friendly architecture"
    ],
    specs: [
      { k: "Modes", v: "Clad / Butt / Fillet" },
      { k: "Positions", v: "1G / 2G / 5G" },
      { k: "Process", v: "TIG / Hot Wire TIG" },
      { k: "Footprint", v: "Single station" },
      { k: "Control", v: "PLC + HMI" }
    ],
    applications: ["Versatile cladding routines", "Complex profiles", "Multi-position welding"],
    industries: ["Valve Manufacturing", "EPC Contractors", "Heavy Engineering"],
    advantages: [
      "Consolidates 3 machines into 1",
      "Reduces capex & floor space",
      "Flexible across mixed part families"
    ]
  },
  {
    slug: "dynamic-rotational-torch",
    name: "Dynamic Rotational Torch System",
    short: "DRT · Multi-Angle Borehole Overlay",
    tagline: "Multi-angle, multi-bore borehole overlay with auto-centring — the part stays put, the torch does the work.",
    image: W_DRT,
    image_secondary: W_DRT_HERO,
    hero: W_DRT_HERO,
    description:
      "The Dynamic Rotational Torch (DRT) system is engineered for multi-angle borehole overlay on valve bodies, large pipe fittings and hub-type components. Auto-centring technology and programmed geometry routines eliminate manual indication and let one fixture handle multiple bores at different axes.",
    features: [
      "Auto-centring torch technology",
      "Fixed-job advantage — workpiece stays stationary",
      "Programmed geometry routines",
      "Hot Wire TIG cladding",
      "Data-logged operation with telemetry",
      "Touch-screen HMI with weld parameter logging"
    ],
    specs: [
      { k: "Cladding Mode", v: "ID & OD" },
      { k: "Process", v: "Hot Wire TIG" },
      { k: "Capability", v: "Multi-angle · Multi-bore" },
      { k: "Pipe Range", v: "DN50 – DN1200" },
      { k: "Deposition", v: "Up to 12 kg/hr" }
    ],
    applications: ["Valve bodies", "Large pipe fittings", "Hubs · Race-tracks · Ring grooves", "Cylindrical & conical bores"],
    industries: ["Oil & Gas", "Valve & Choke Manufacturing", "Petrochemical"],
    advantages: [
      "Eliminates manual indication / set-up",
      "Cladding of multiple bores without re-fixturing",
      "Industry-leading deposition rate"
    ]
  },
  {
    slug: "vertical-cladding-system",
    name: "Vertical Cladding System",
    short: "VCS · PLC Hot-Wire Pulsed TIG",
    tagline: "PLC-driven Hot-Wire Pulsed TIG vertical cladding — base and bore in a single platform.",
    image: W_VCS,
    image_secondary: W_VCS,
    hero: W_VCS,
    description:
      "High-precision internal overlay station for vertical workpieces — vessels, headers and short pipe spools. PLC-based Hot-Wire Pulsed TIG with auto AVC (Automatic Voltage Control) and auto-speed compensation delivers tight tolerances and superior overlay geometry.",
    features: [
      "Base & bore cladding capability",
      "PLC-based Hot-Wire Pulsed TIG",
      "Auto AVC — Automatic Voltage Control",
      "Auto-speed compensation",
      "Virtual pendant HMI",
      "Touch-retract for consistent arc starts"
    ],
    specs: [
      { k: "Bore Range", v: "Ø80 – Ø500 mm" },
      { k: "Positions", v: "1G & 2G" },
      { k: "Process", v: "Hot Wire Pulsed TIG" },
      { k: "Control", v: "Full PLC + HMI" },
      { k: "Footprint", v: "Compact" }
    ],
    applications: ["Internal bore cladding", "External base cladding", "Header & vessel nozzle overlay"],
    industries: ["Power Generation", "Petrochemical", "Oil & Gas"],
    advantages: [
      "Tight overlay tolerance",
      "Consistent arc starts via touch-retract",
      "Compact floor footprint"
    ]
  },
  {
    slug: "pipe-cladding-rig",
    name: "Pipe Cladding Rig — Twin & Quad Head",
    short: "Pipe Cladding · 6\"–36\"",
    tagline: "HW-TIG internal overlay rigs with twin & quad-torch configurations for 6\"–36\" CRA pipe.",
    image: W_PIPE,
    image_secondary: W_PIPE_HERO,
    hero: W_PIPE_HERO,
    description:
      "Production-grade pipe cladding rig engineered for CRA pipe manufacturers. Pipe rotates on precision rollers under a stiffened lance with twin or quad HW-TIG torches for optimized low-dilution overlay at high throughput — built for 3-shift operations.",
    features: [
      "Twin-head & Quad-head variants",
      "Precision rotator rollers",
      "Stiffened lance guidance",
      "Hot Wire TIG — single or twin wire",
      "Auto wire feed & oscillation",
      "Integrated weld data logging"
    ],
    specs: [
      { k: "Pipe Diameter", v: "6\" – 36\"" },
      { k: "Pipe Length", v: "1 m – 12 m" },
      { k: "Torches", v: "2 / 4 (HW-TIG)" },
      { k: "Wire", v: "Single or twin" },
      { k: "Duty Cycle", v: "100% — 3-shift" }
    ],
    applications: ["Internal CRA overlay", "Subsea flowline cladding", "Production cladding lines"],
    industries: ["Oil & Gas", "CRA Pipe Manufacturing", "EPC Contractors"],
    advantages: [
      "Near-mirror finish with low dilution",
      "Up to 4× throughput vs single-torch",
      "Engineered for 3-shift operations"
    ]
  },
  {
    slug: "auto-dpt-rig",
    name: "Auto DPT Rig — Pipe Flaw Detection Skid",
    short: "Auto DPT · Closed-Loop NDT",
    tagline: "Closed-loop dye-penetrant inspection skid — repeatable NDT with full process traceability.",
    image: A_AUTO_DPT,
    image_secondary: W_DPT_OLD,
    hero: A_AUTO_DPT,
    description:
      "A closed-loop dye-penetrant inspection skid engineered for the high-volume pipe shop. VFD-pumped spray, precision-engineered jets and integrated process telemetry deliver repeatable inspection quality — every part, every time. Designed to dock with cladding lines for inline NDT.",
    features: [
      "VFD-pumped closed-loop system",
      "Precision-engineered spray jets",
      "Integrated process telemetry",
      "Docks with cladding lines (inline NDT)",
      "Operator HMI with recipe memory",
      "Full audit trail per part"
    ],
    specs: [
      { k: "Pipe Diameter", v: "8\" +" },
      { k: "Pipe Length", v: "1.5 m – 12 m" },
      { k: "Control", v: "PLC + HMI" },
      { k: "Standard", v: "ASME / ASTM" }
    ],
    applications: ["Post-clad NDT", "Post-weld inspection", "Inline pipe flaw detection"],
    industries: ["Oil & Gas", "Power Generation", "Process Piping"],
    advantages: [
      "Eliminates operator variability",
      "Closed-loop spray control for repeatability",
      "Full audit trail per part"
    ]
  },
  {
    slug: "butt-welding-station",
    name: "Butt Welding Station",
    short: "Butt Weld · Precision Pipe & Spool",
    tagline: "Servo-driven precision butt welding with synergic power and full code-quality traceability.",
    image: A_BUTT_WELD,
    image_secondary: A_BUTT_WELD,
    hero: A_BUTT_WELD,
    description:
      "Engineered for precision butt welding of pipes, spools and pressure parts. Servo rotator and carriage paired with EWM synergic power deliver auto hotpass / fill / cap sequencing, code-quality root passes and time-stamped per-weld traceability.",
    features: [
      "Servo rotator + carriage",
      "EWM synergic power source",
      "Auto hotpass / fill / cap sequencing",
      "Tacking & alignment fixtures",
      "Time-stamped weld parameter logging",
      "Code-quality assurance"
    ],
    specs: [
      { k: "Process", v: "GTAW / GMAW" },
      { k: "Pipe OD", v: "Ø50 – Ø500 mm" },
      { k: "Position", v: "1G rotated" },
      { k: "Control", v: "PLC + HMI" }
    ],
    applications: ["Pipe spool fabrication", "Pressure parts", "Sub-assembly welding", "EPC project execution"],
    industries: ["EPC Contractors", "Oil & Gas", "Power Generation"],
    advantages: [
      "Code-quality welds repeatably",
      "Full traceability per weld",
      "Reduced rework & rejects"
    ]
  },
  {
    slug: "boiler-tube-cladding-station",
    name: "Boiler Tube Cladding Station",
    short: "BTC · Precision. Superior Performance.",
    tagline: "Containerized cladding cell for boiler tubes — water-cooled, ±0.2 mm precision, shop-floor ready.",
    image: A_BOILER_TUBE,
    image_secondary: A_BOILER_TUBE,
    hero: A_BOILER_TUBE,
    description:
      "Precision-engineered containerized cladding cell for boiler tubes. Motorized headstock, torch slide on a rear track and adjustable support rollers ensure ±0.2 mm positional accuracy. Internal water-cooling prevents distortion across long tube runs. The containerized design protects the cell from shop-floor elements.",
    features: [
      "Motorized headstock",
      "Torch slide on rear track",
      "Adjustable support rollers",
      "Internal water-cooled tube clamping",
      "Containerized cell architecture",
      "PLC + HMI control"
    ],
    specs: [
      { k: "Tube Diameter", v: "1\" – 8\"" },
      { k: "Length", v: "up to 12,000 mm" },
      { k: "Power", v: "450 A, 3-Phase" },
      { k: "Positional Accuracy", v: "±0.2 mm" },
      { k: "Cooling", v: "Internal water flow" }
    ],
    applications: ["High-precision boiler tube cladding", "Inconel overlay on long tube runs"],
    industries: ["Power Generation", "Waste to Energy"],
    advantages: [
      "Water flow prevents distortion / overheating",
      "Containerized — protected from shop floor elements",
      "Repeatable ±0.2 mm overlay geometry"
    ]
  },
  {
    slug: "twin-head-tube-wall-cladding",
    name: "Twin Head Boiler Tube & Tube Wall Cladding System",
    short: "Tube Wall · Twin-Torch Overlay",
    tagline: "High-productivity twin-torch overlay for boiler tube panels — parallel deposition, ±0.2 mm accuracy.",
    image: A_BOILER_WALL,
    image_secondary: A_BOILER_WALL,
    hero: A_BOILER_WALL,
    description:
      "Purpose-built for boiler tube panels and waste-to-energy applications. Independent twin torches with dedicated wire feeders deposit in parallel across panel widths up to 3 m. Servo-controlled linear axes and water-cooled torches sustain duty cycles required by 3-shift overlay operations.",
    features: [
      "Independent twin torches",
      "Dual wire feeders",
      "Water-cooled torches",
      "Servo-controlled linear axes",
      "Panel-width gantry overlay",
      "PLC + HMI control"
    ],
    specs: [
      { k: "Panel Width", v: "Up to 3 m" },
      { k: "Travel Speed", v: "50 – 1,000 mm/min" },
      { k: "Weld Speed", v: "50 – 800 mm/min" },
      { k: "Positioning Accuracy", v: "±0.2 mm" },
      { k: "Process", v: "Hot Wire TIG / GMAW" }
    ],
    applications: ["Waste-to-energy boiler tubes", "Power plant tube panels", "Tube wall overlay"],
    industries: ["Waste to Energy", "Power Generation", "Heavy Engineering"],
    advantages: [
      "Parallel deposition — significantly higher productivity",
      "Low dilution overlay",
      "Built for harsh-duty cycles"
    ]
  },
  {
    slug: "laser-clad-cutting",
    name: "Laser Clad & Cutting Solutions",
    short: "Laser · High-Energy Beam Platforms",
    tagline: "Bespoke high-energy beam platforms for low-heat-input cladding and fine-feature cutting.",
    image: A_LASER,
    image_secondary: A_LASER,
    hero: A_LASER,
    description:
      "Engineered, bespoke laser clad and cutting platforms for specialised applications where heat-input control and feature precision are critical. Minimal heat-affected zone (HAZ), exceptional distortion control, and a build-to-order architecture for defence, aerospace and high-tech manufacturing.",
    features: [
      "Low-heat-input deposition",
      "Fine-feature cutting capability",
      "Bespoke integration — built to project spec",
      "Minimal HAZ & distortion",
      "Closed-loop process monitoring"
    ],
    specs: [
      { k: "Configuration", v: "Custom-engineered" },
      { k: "Process", v: "Laser Clad / Cut" },
      { k: "Heat Input", v: "Low (controlled)" },
      { k: "Integration", v: "Bespoke per project" }
    ],
    applications: ["Thin-wall components", "Dissimilar metal joins", "Complex profiles", "High-precision overlay"],
    industries: ["Defence & Aerospace", "High-Tech Manufacturing", "R&D Centres"],
    advantages: [
      "Minimal HAZ — almost zero distortion",
      "Extremely high precision",
      "Built bespoke for the application"
    ]
  },
  {
    slug: "custom-automation",
    name: "Custom Built Tailored Welding & Weld Overlay Automation",
    short: "Bespoke · Engineered to Your Spec",
    tagline: "Engineering-first bespoke welding & weld overlay automation, designed and built around your application.",
    image: A_CUSTOM_1,
    image_secondary: A_CUSTOM_2,
    hero: A_CUSTOM_1,
    description:
      "For applications outside the standard catalogue, our in-house engineering team designs and builds tailored welding and weld overlay automation — from concept through to commissioning. Process qualification, mechanical & control engineering, fabrication, FAT and on-site SAT — all delivered under one accountable OEM.",
    features: [
      "Bespoke mechanical & control engineering",
      "Process qualification trials",
      "In-house fabrication & assembly",
      "Custom HMI / PLC / servo architecture",
      "FAT + SAT under one roof",
      "Lifetime service & spares"
    ],
    specs: [
      { k: "Scope", v: "Concept → Commissioning" },
      { k: "Engineering", v: "Mechanical · Electrical · PLC · HMI" },
      { k: "Process Trials", v: "Included" },
      { k: "Documentation", v: "Code-level (ASME / ISO)" }
    ],
    applications: [
      "Special part geometries",
      "Non-standard pipe / vessel cladding",
      "Robotic integration",
      "Customer-specific production lines"
    ],
    industries: ["All — Oil & Gas, Power, Nuclear, EPC, Heavy Engineering"],
    advantages: [
      "Single accountable OEM — design to support",
      "Process-first engineering",
      "Tailored to your production economics"
    ]
  }
];

export const productBySlug = (slug) => PRODUCTS.find((p) => p.slug === slug);
